import React from "react";
import { ArrowRightIcon, CircleCheckIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CTAButtonProps = {
  label: string;
  compact?: boolean;
  shake?: boolean;
  className?: string;
};
export function CTAButton({
  label,
  compact = false,
  shake = false,
  className = ""
}: CTAButtonProps) {
  return <a href={CHECKOUT_URL} className={`flex w-full items-center justify-center gap-3 rounded-2xl bg-cta text-center font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_12px_28px_-10px_rgba(22,163,74,0.75)] ring-1 ring-inset ring-white/15 transition-[transform,background-color] duration-150 ease-out hover:bg-cta-dark active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 ${compact ? "px-4 py-3.5 text-[15px]" : "px-5 py-5 text-[16px] md:text-xl"} ${shake ? "animate-cta-shake" : ""} ${className}`} data-id="element-103" data-mp="2fy0erlvcynyh">
      <CircleCheckIcon className={compact ? "h-5 w-5 shrink-0" : "h-6 w-6 shrink-0"} aria-hidden="true" data-id="element-104" data-mp="38pk1vgv2sm5r" />
      <span className="text-balance" data-id="element-105" data-mp="19a7u9pttbk3m">{label}</span>
      <ArrowRightIcon className="hidden h-5 w-5 shrink-0 sm:block" aria-hidden="true" data-id="element-106" data-mp="1da8bfi8aq9ed" />
    </a>;
}